export const SITE_NAME = "Local Ranking Coach";
export { SITE_ORIGIN } from "@shared/const";
export const SITE_TAGLINE = "Boosting Trades to the Top";
export const SITE_PHONE = "1-800-301-6220";
export const SITE_EMAIL = "service@localrankingcoach.com";
export const LOGO_URL = "/images/logo.png";
export const FOOTER_LOGO_URL = "/images/logo-footer.webp";

export const services = [
  {
    slug: "local-seo",
    title: "Local SEO Services",
    shortDesc: "Rank higher in local search, improve Google Maps visibility, generate qualified leads, and attract more nearby customers with proven local SEO strategies.",
    icon: "MapPin",
    color: "gold",
    metaTitle: "Local SEO Services | Local Ranking Coach",
    metaDesc: "Local SEO services that help businesses rank higher locally, improve Google Maps visibility, generate qualified leads, and attract more nearby customers.",
  },
  {
    slug: "on-page-seo",
    title: "On-Page SEO & Technical SEO",
    shortDesc: "Optimize title tags, meta descriptions, content structure, Core Web Vitals, schema markup, and site architecture to improve rankings and organic traffic.",
    icon: "FileText",
    color: "navy",
    metaTitle: "On-Page SEO Services & Technical SEO Optimization | Local Ranking Coach",
    metaDesc: "Professional On-Page SEO Services and Technical SEO Optimization helping businesses improve Google rankings, organic traffic, user experience, and conversions.",
  },
  {
    slug: "technical-seo",
    title: "Technical SEO",
    shortDesc: "Fix crawl errors, improve site speed, and ensure search engines can index every page of your website flawlessly.",
    icon: "Settings",
    color: "gold",
    metaTitle: "Technical SEO Services | Local Ranking Coach — Site Speed & Crawlability Experts",
    metaDesc: "Expert technical SEO services that fix crawl errors, improve Core Web Vitals, and ensure search engines can index your website for maximum rankings.",
  },
  {
    slug: "link-building",
    title: "Link Building SEO",
    shortDesc: "Earn high-quality backlinks from relevant, trusted websites to build domain authority, improve rankings, and drive more organic traffic.",
    icon: "Link2",
    color: "navy",
    metaTitle: "Link Building SEO Services | Local Ranking Coach",
    metaDesc: "Complete link building SEO services including backlink audits, guest posting, broken link building, digital PR, local citation building, and monthly link reporting.",
  },
  {
    slug: "google-business-profile",
    title: "Google Business Profile SEO",
    shortDesc: "Improve your Google Maps rankings and generate more local calls, leads, and customers with professional Google Business Profile optimization.",
    icon: "MapPin",
    color: "gold",
    metaTitle: "Google Business Profile SEO Services | Local Ranking Coach",
    metaDesc: "Google Business Profile SEO services helping businesses improve Google Maps rankings, increase local visibility, generate more calls, and dominate local search results.",
  },
  {
    slug: "citation-building",
    title: "Citation Building",
    shortDesc: "Build consistent NAP citations across hundreds of directories to strengthen your local search authority.",
    icon: "BookOpen",
    color: "navy",
    metaTitle: "Citation Building Services | Local Ranking Coach — NAP Consistency Experts",
    metaDesc: "Professional citation building services that create consistent NAP listings across hundreds of directories to strengthen your local search authority and rankings.",
  },

  {
    slug: "seo-audits",
    title: "SEO Audits",
    shortDesc: "Comprehensive technical and content audits that reveal exactly what's holding your rankings back — and how to fix it.",
    icon: "Search",
    color: "navy",
    metaTitle: "SEO Audit Services | Local Ranking Coach — Comprehensive Website SEO Analysis",
    metaDesc: "Comprehensive SEO audit services that identify every technical and content issue holding your rankings back, with a clear roadmap to fix them.",
  },
  {
    slug: "ecommerce-seo",
    title: "E-commerce SEO",
    shortDesc: "Drive qualified organic traffic to your online store with product-level SEO strategies that increase sales.",
    icon: "ShoppingCart",
    color: "gold",
    metaTitle: "E-commerce SEO Services | Local Ranking Coach — Online Store SEO Experts",
    metaDesc: "Expert e-commerce SEO services that drive qualified organic traffic to your online store with product-level optimization strategies that increase sales.",
  },
  {
    slug: "national-seo",
    title: "National SEO",
    shortDesc: "Scale your visibility across the entire United States with enterprise-level SEO strategies built for growth.",
    icon: "Globe",
    color: "navy",
    metaTitle: "National SEO Services | Local Ranking Coach — Enterprise SEO for US Businesses",
    metaDesc: "Enterprise-level national SEO services that scale your visibility across the entire United States with proven strategies built for sustainable growth.",
  },
  {
    slug: "aeo-agency",
    title: "AEO Agency",
    shortDesc: "Appear in AI-generated answers, featured snippets, voice search, and Google AI Overviews with Answer Engine Optimization.",
    icon: "Brain",
    color: "gold",
    metaTitle: "AEO Agency | Answer Engine Optimization Services | Local Ranking Coach",
    metaDesc: "AEO Agency offering Answer Engine Optimization services to help businesses appear in AI search results, Google AI Overviews, ChatGPT, voice search, featured snippets, and answer engines.",
  },
  {
    slug: "aeo-agency/aio-seo",
    title: "AI Search Optimization",
    shortDesc: "Get found in ChatGPT, Google AI Overviews, Gemini, and voice search with our MERIT Framework AI search optimization.",
    icon: "Cpu",
    color: "navy",
    metaTitle: "AI Search Optimization Services | Local Ranking Coach",
    metaDesc: "AI Search Optimization Services helping businesses appear in ChatGPT, Google AI Overviews, Gemini, voice search, and traditional search results.",
  },
  {
    slug: "aeo-agency/geo-seo",
    title: "Generative Engine Optimization",
    shortDesc: "Get cited in Google AI Overviews, ChatGPT, Perplexity, Gemini, and Bing Copilot with our Generative Engine Optimization (GEO) services.",
    icon: "Layers",
    color: "gold",
    metaTitle: "Generative Engine Optimization | Local Ranking Coach",
    metaDesc: "Generative Engine Optimization services that help businesses appear in Google AI Overviews, ChatGPT, Perplexity, Gemini, Bing Copilot, and AI-powered search results.",
  },
  {
    slug: "aeo-agency/chatgpt-seo",
    title: "ChatGPT SEO",
    shortDesc: "Get cited and recommended inside ChatGPT Search, Claude, Gemini, and Perplexity with our AI-first semantic SEO and E-E-A-T optimization strategy.",
    icon: "Bot",
    color: "navy",
    metaTitle: "ChatGPT SEO Agency | AI Search Optimization for ChatGPT, Claude, Gemini & Perplexity",
    metaDesc: "ChatGPT SEO services that help businesses get cited and recommended inside ChatGPT Search, Claude, Gemini, Perplexity, and Google AI Overviews.",
  },
  {
    slug: "aeo-agency/claude-seo",
    title: "Claude SEO",
    shortDesc: "Optimize your business to be cited and recommended inside Anthropic's Claude AI — with entity SEO, semantic content architecture, structured data, and E-E-A-T strategy.",
    icon: "Brain",
    color: "violet",
    metaTitle: "Claude SEO Agency | Anthropic Claude AI Search Optimization Services",
    metaDesc: "Professional Claude SEO services that help businesses get cited and recommended inside Anthropic's Claude, ChatGPT, Gemini, Perplexity, and Google AI Overviews.",
  },
  {
    slug: "aeo-agency/gemini-seo",
    title: "Gemini SEO",
    shortDesc: "Get cited in Google Gemini, AI Overviews, and AI Mode through semantic SEO, entity optimization, and E-E-A-T strategy.",
    icon: "Globe",
    color: "blue",
    metaTitle: "Gemini SEO Services | Google AI Overviews & AI Mode Optimization | Local Ranking Coach",
    metaDesc: "Professional Gemini SEO services that help businesses get cited in Google Gemini, AI Overviews, AI Mode, and AI-powered search experiences through semantic SEO, entity optimization, and E-E-A-T strategy.",
  },
  {
    slug: "aeo-agency/perplexity-seo",
    title: "Perplexity SEO",
    shortDesc: "Get cited in Perplexity AI — the fastest-growing AI search engine — through RAG optimization, entity SEO, and answer-first content strategy.",
    icon: "Zap",
    color: "navy",
    metaTitle: "Perplexity SEO Agency | AI Search Optimization for Perplexity AI | Local Ranking Coach",
    metaDesc: "Professional Perplexity SEO services that help businesses get cited in Perplexity AI, Claude, Gemini, ChatGPT, and Google AI Overviews through semantic SEO, entity optimization, and E-E-A-T strategy.",
  },
  {
    slug: "aeo-agency/llm-seo",
    title: "LLM SEO",
    shortDesc: "Large Language Model SEO across ChatGPT, Gemini, Claude, Perplexity, and all major AI platforms.",
    icon: "Network",
    color: "navy",
    metaTitle: "LLM SEO Services | Large Language Model Optimization | Local Ranking Coach",
    metaDesc: "LLM SEO services that optimize your brand across all major large language models — ChatGPT, Gemini, Claude, Perplexity, and Copilot — through a unified AI citation strategy.",
  },
  {
    slug: "ppc-management",
    title: "PPC Management",
    shortDesc: "Generate high-quality leads immediately with Google Ads, Bing Ads, Local Service Ads, and cross-platform paid media campaigns managed by certified PPC experts.",
    icon: "TrendingUp",
    color: "navy",
    metaTitle: "PPC Management Agency | Pay Per Click Services | Local Ranking Coach",
    metaDesc: "Pay Per Click Management Agency helping businesses generate high-quality leads through Google Ads, Bing Ads, Local Service Ads, PPC strategy, landing page optimization, and conversion tracking.",
  },
  {
    slug: "semantic-seo",
    title: "Semantic SEO",
    shortDesc: "Build topical authority, optimize for search intent, and align your content with how modern search engines understand entities, context, and semantic relationships.",
    icon: "Brain",
    color: "gold",
    metaTitle: "Semantic SEO Services | Topical Authority & Entity Optimization | Local Ranking Coach",
    metaDesc: "Semantic SEO services and strategies focused on topical authority, search intent, entity optimization, semantic content, structured data, and modern search engine optimization.",
  },
  {
    slug: "social-media-ads",
    title: "Social Media Ads",
    shortDesc: "Full-service social media advertising campaigns — Facebook, Instagram, TikTok, LinkedIn, and YouTube ads with audience targeting, creative development, and ROI reporting.",
    icon: "Share2",
    color: "navy",
    metaTitle: "Social Media Advertising Services | Facebook, Instagram, TikTok Ads | Local Ranking Coach",
    metaDesc: "Social media advertising services for small businesses including Facebook Ads, Instagram Ads, TikTok Ads, LinkedIn Ads, YouTube Ads, lead generation, retargeting, and social media management.",
  },
  {
    slug: "content-marketing",
    title: "Content Marketing",
    shortDesc: "SEO-driven content strategies that build topical authority, attract high-intent organic traffic, and convert readers into booked jobs — blog writing, service pages, location pages, and more.",
    icon: "FileText",
    color: "gold",
    metaTitle: "Content Marketing Services for Contractors & Local Businesses | Local Ranking Coach",
    metaDesc: "Content marketing services for contractors and local businesses — SEO blog writing, service page content, topical authority building, and content strategy that drives organic traffic and qualified leads.",
  },
  {
    slug: "reputation-management",
    title: "Reputation Management",
    shortDesc: "Build and protect your 5-star online reputation — review generation, negative review suppression, Google Business Profile reputation optimization, and multi-platform monitoring.",
    icon: "Star",
    color: "gold",
    metaTitle: "Reputation Management Services for Contractors & Local Businesses | Local Ranking Coach",
    metaDesc: "Reputation management services for contractors and local businesses — review generation, negative review suppression, Google Business Profile reputation optimization, and online reputation monitoring.",
  },
  {
    slug: "website-design",
    title: "Website Design & Development",
    shortDesc: "SEO-first contractor websites built to rank in Google, load fast, and convert visitors into booked jobs — custom design, mobile-optimized, with schema markup on every page.",
    icon: "Monitor",
    color: "navy",
    metaTitle: "Website Design & Development for Contractors & Local Businesses | Local Ranking Coach",
    metaDesc: "SEO-first website design and development for contractors and local businesses. Fast-loading, mobile-optimized, conversion-focused websites built to rank in Google and generate leads.",
  },
];

export { CANONICAL_INDUSTRY_SLUGS } from "@shared/const";
import { CANONICAL_INDUSTRY_SLUGS } from "@shared/const";

/** Base slug without trailing `-seo` (e.g. `healthcare-seo` → `healthcare`). */
export function industryBaseSlug(slug: string): string {
  return slug.replace(/-seo$/, "");
}

/** Canonical href for an industry page (uses `-seo` URLs where a dedicated page exists). */
export function getIndustryHref(slug: string): string {
  const base = industryBaseSlug(slug);
  const canonical = CANONICAL_INDUSTRY_SLUGS[base] ?? slug;
  return `/industries/${canonical}`;
}

export const industries = [
  { slug: "healthcare", title: "Healthcare", icon: "Heart", desc: "Medical practices, clinics, and healthcare providers" },
  { slug: "legal", title: "Legal", icon: "Scale", desc: "Law firms, attorneys, and legal services" },
  { slug: "real-estate", title: "Real Estate", icon: "Home", desc: "Agents, brokers, and property management" },
  { slug: "home-services", title: "Home Services", icon: "Wrench", desc: "HVAC, plumbing, electrical, and contractors" },
  { slug: "restaurants", title: "Restaurants", icon: "UtensilsCrossed", desc: "Restaurants, cafes, and food service" },
  { slug: "automotive", title: "Automotive", icon: "Car", desc: "Auto dealers, repair shops, and detailing" },
  { slug: "dental", title: "Dental", icon: "Smile", desc: "Dentists, orthodontists, and dental specialists" },
  { slug: "finance", title: "Finance", icon: "DollarSign", desc: "Financial advisors, accountants, and lenders" },
  { slug: "retail", title: "Retail", icon: "ShoppingBag", desc: "Local shops, boutiques, and retail stores" },
  { slug: "education", title: "Education", icon: "GraduationCap", desc: "Schools, tutoring centers, and training programs" },
];

export const cities = [
  // Florida
  { slug: "florida/tampa-seo", name: "Tampa", state: "FL" },
  { slug: "florida/orlando-seo", name: "Orlando", state: "FL" },
  { slug: "florida/miami-seo", name: "Miami", state: "FL" },
  { slug: "florida/jacksonville-seo", name: "Jacksonville", state: "FL" },
  { slug: "florida/st-petersburg-seo", name: "St. Petersburg", state: "FL" },
  { slug: "florida/fort-lauderdale-seo", name: "Fort Lauderdale", state: "FL" },
  { slug: "florida/tallahassee-seo", name: "Tallahassee", state: "FL" },
  { slug: "florida/cape-coral-seo", name: "Cape Coral", state: "FL" },
  { slug: "florida/fort-myers-seo", name: "Fort Myers", state: "FL" },
  { slug: "florida/naples-seo", name: "Naples", state: "FL" },
  { slug: "florida/sarasota-seo", name: "Sarasota", state: "FL" },
  { slug: "florida/gainesville-seo", name: "Gainesville", state: "FL" },
  { slug: "florida/pensacola-seo", name: "Pensacola", state: "FL" },
  { slug: "florida/port-st-lucie-seo", name: "Port St. Lucie", state: "FL" },
  { slug: "florida/hialeah-seo", name: "Hialeah", state: "FL" },
  { slug: "florida/clearwater-seo", name: "Clearwater", state: "FL" },
  { slug: "florida/pompano-beach-seo", name: "Pompano Beach", state: "FL" },
  { slug: "florida/west-palm-beach-seo", name: "West Palm Beach", state: "FL" },
  { slug: "florida/lakeland-seo", name: "Lakeland", state: "FL" },
  { slug: "florida/daytona-beach-seo", name: "Daytona Beach", state: "FL" },
  { slug: "florida/boca-raton-seo", name: "Boca Raton", state: "FL" },
  { slug: "florida/ocala-seo", name: "Ocala", state: "FL" },
  { slug: "florida/melbourne-seo", name: "Melbourne", state: "FL" },
  { slug: "florida/palm-bay-seo", name: "Palm Bay", state: "FL" },
  { slug: "florida/panama-city-seo", name: "Panama City", state: "FL" },
  // Florida — New Cities
  { slug: "florida/miami-gardens-seo", name: "Miami Gardens", state: "FL" },
  { slug: "florida/sunrise-seo", name: "Sunrise", state: "FL" },
  { slug: "florida/plantation-seo", name: "Plantation", state: "FL" },
  { slug: "florida/deerfield-beach-seo", name: "Deerfield Beach", state: "FL" },
  { slug: "florida/orlando-seo/altamonte-springs-seo", name: "Altamonte Springs", state: "FL" },
  { slug: "florida/orlando-seo/casselberry-seo", name: "Casselberry", state: "FL" },
  { slug: "florida/orlando-seo/apopka-seo", name: "Apopka", state: "FL" },
  { slug: "florida/orlando-seo/longwood-seo", name: "Longwood", state: "FL" },
  { slug: "florida/orlando-seo/lake-mary-seo", name: "Lake Mary", state: "FL" },
  { slug: "florida/the-villages-seo", name: "The Villages", state: "FL" },
  { slug: "florida/davenport-seo", name: "Davenport", state: "FL" },
  { slug: "florida/orlando-seo/sanford-seo", name: "Sanford", state: "FL" },
  { slug: "florida/new-port-richey-seo", name: "New Port Richey", state: "FL" },
  { slug: "florida/orlando-seo/lake-nona-seo", name: "Lake Nona", state: "FL" },
  { slug: "florida/orlando-seo/downtown-orlando-seo", name: "Downtown Orlando", state: "FL" },
  { slug: "florida/orlando-seo/winter-park-seo", name: "Winter Park", state: "FL" },
  { slug: "florida/orlando-seo/winter-garden-seo", name: "Winter Garden", state: "FL" },
  { slug: "florida/clermont-seo", name: "Clermont", state: "FL" },
  // Georgia
  { slug: "georgia/atlanta-seo", name: "Atlanta", state: "GA" },
  { slug: "georgia/columbus-seo", name: "Columbus", state: "GA" },
  { slug: "georgia/augusta-seo", name: "Augusta", state: "GA" },
  { slug: "georgia/macon-seo", name: "Macon", state: "GA" },
  { slug: "georgia/savannah-seo", name: "Savannah", state: "GA" },
  { slug: "georgia/athens-seo", name: "Athens", state: "GA" },
  { slug: "georgia/sandy-springs-seo", name: "Sandy Springs", state: "GA" },
  { slug: "georgia/south-fulton-seo", name: "South Fulton", state: "GA" },
  { slug: "georgia/roswell-seo", name: "Roswell", state: "GA" },
  // Texas
  { slug: "texas/houston-seo", name: "Houston", state: "TX" },
  { slug: "texas/dallas-seo", name: "Dallas", state: "TX" },
  { slug: "texas/austin-seo", name: "Austin", state: "TX" },
  { slug: "texas/san-antonio-seo", name: "San Antonio", state: "TX" },
  { slug: "texas/fort-worth-seo", name: "Fort Worth", state: "TX" },
  { slug: "texas/el-paso-seo", name: "El Paso", state: "TX" },
  { slug: "texas/arlington-seo", name: "Arlington", state: "TX" },
  { slug: "texas/corpus-christi-seo", name: "Corpus Christi", state: "TX" },
  // North Carolina
  { slug: "charlotte-nc", name: "Charlotte", state: "NC" },
  // Illinois
  { slug: "illinois/chicago-seo", name: "Chicago", state: "IL" },
  { slug: "illinois/aurora-seo", name: "Aurora", state: "IL" },
  { slug: "illinois/joliet-seo", name: "Joliet", state: "IL" },
  { slug: "illinois/naperville-seo", name: "Naperville", state: "IL" },
  { slug: "illinois/rockford-seo", name: "Rockford", state: "IL" },
  { slug: "illinois/elgin-seo", name: "Elgin", state: "IL" },
  { slug: "illinois/springfield-seo", name: "Springfield", state: "IL" },
  { slug: "illinois/peoria-seo", name: "Peoria", state: "IL" },
  { slug: "illinois/champaign-seo", name: "Champaign", state: "IL" },
  { slug: "illinois/waukegan-seo", name: "Waukegan", state: "IL" },
  // Tennessee
  { slug: "memphis-tn", name: "Memphis", state: "TN" },
  // Louisiana
  { slug: "louisiana/new-orleans-seo", name: "New Orleans", state: "LA" },
  { slug: "louisiana/baton-rouge-seo", name: "Baton Rouge", state: "LA" },
  { slug: "louisiana/shreveport-seo", name: "Shreveport", state: "LA" },
  { slug: "louisiana/metairie-seo", name: "Metairie", state: "LA" },
  { slug: "louisiana/lafayette-seo", name: "Lafayette", state: "LA" },
  { slug: "louisiana/lake-charles-seo", name: "Lake Charles", state: "LA" },
  { slug: "louisiana/kenner-seo", name: "Kenner", state: "LA" },
  { slug: "louisiana/bossier-city-seo", name: "Bossier City", state: "LA" },
  { slug: "louisiana/monroe-seo", name: "Monroe", state: "LA" },
  // Indiana
  { slug: "indiana/indianapolis-seo", name: "Indianapolis", state: "IN" },
  { slug: "indiana/fort-wayne-seo", name: "Fort Wayne", state: "IN" },
  { slug: "indiana/evansville-seo", name: "Evansville", state: "IN" },
  { slug: "indiana/south-bend-seo", name: "South Bend", state: "IN" },
  { slug: "indiana/carmel-seo", name: "Carmel", state: "IN" },
  { slug: "indiana/fishers-seo", name: "Fishers", state: "IN" },
  { slug: "indiana/hammond-seo", name: "Hammond", state: "IN" },
  { slug: "indiana/gary-seo", name: "Gary", state: "IN" },
  { slug: "indiana/muncie-seo", name: "Muncie", state: "IN" },
  { slug: "indiana/terre-haute-seo", name: "Terre Haute", state: "IN" },
  // Ohio
  { slug: "ohio/columbus-seo", name: "Columbus", state: "OH" },
  { slug: "ohio/cleveland-seo", name: "Cleveland", state: "OH" },
  { slug: "ohio/cincinnati-seo", name: "Cincinnati", state: "OH" },
  { slug: "ohio/toledo-seo", name: "Toledo", state: "OH" },
  { slug: "ohio/akron-seo", name: "Akron", state: "OH" },
  { slug: "ohio/dayton-seo", name: "Dayton", state: "OH" },
  { slug: "ohio/parma-seo", name: "Parma", state: "OH" },
  { slug: "ohio/canton-seo", name: "Canton", state: "OH" },
  { slug: "ohio/youngstown-seo", name: "Youngstown", state: "OH" },
  { slug: "ohio/lorain-seo", name: "Lorain", state: "OH" },
  // Nevada
  { slug: "nevada/las-vegas-seo", name: "Las Vegas", state: "NV" },
  { slug: "nevada/henderson-seo", name: "Henderson", state: "NV" },
  { slug: "nevada/reno-seo", name: "Reno", state: "NV" },
  { slug: "nevada/north-las-vegas-seo", name: "North Las Vegas", state: "NV" },
  { slug: "nevada/sparks-seo", name: "Sparks", state: "NV" },
  { slug: "nevada/carson-city-seo", name: "Carson City", state: "NV" },
  { slug: "nevada/fernley-seo", name: "Fernley", state: "NV" },
  { slug: "nevada/elko-seo", name: "Elko", state: "NV" },
  { slug: "nevada/mesquite-seo", name: "Mesquite", state: "NV" },
  { slug: "nevada/boulder-city-seo", name: "Boulder City", state: "NV" },
  // Pennsylvania
  { slug: "pennsylvania/philadelphia-seo", name: "Philadelphia", state: "PA" },
  { slug: "pennsylvania/pittsburgh-seo", name: "Pittsburgh", state: "PA" },
  { slug: "pennsylvania/allentown-seo", name: "Allentown", state: "PA" },
  { slug: "pennsylvania/erie-seo", name: "Erie", state: "PA" },
  { slug: "pennsylvania/reading-seo", name: "Reading", state: "PA" },
  { slug: "pennsylvania/scranton-seo", name: "Scranton", state: "PA" },
  { slug: "pennsylvania/bethlehem-seo", name: "Bethlehem", state: "PA" },
  { slug: "pennsylvania/lancaster-seo", name: "Lancaster", state: "PA" },
  { slug: "pennsylvania/harrisburg-seo", name: "Harrisburg", state: "PA" },
  { slug: "pennsylvania/york-seo", name: "York", state: "PA" },
  // Alabama
  { slug: "alabama/birmingham-seo", name: "Birmingham", state: "AL" },
  { slug: "alabama/montgomery-seo", name: "Montgomery", state: "AL" },
  { slug: "alabama/huntsville-seo", name: "Huntsville", state: "AL" },
  { slug: "alabama/mobile-seo", name: "Mobile", state: "AL" },
  { slug: "alabama/tuscaloosa-seo", name: "Tuscaloosa", state: "AL" },
  { slug: "alabama/hoover-seo", name: "Hoover", state: "AL" },
  { slug: "alabama/dothan-seo", name: "Dothan", state: "AL" },
  { slug: "alabama/auburn-seo", name: "Auburn", state: "AL" },
  { slug: "alabama/decatur-seo", name: "Decatur", state: "AL" },
  { slug: "alabama/madison-seo", name: "Madison", state: "AL" },
  // Virginia
  { slug: "virginia/virginia-beach-seo", name: "Virginia Beach", state: "VA" },
  { slug: "virginia/norfolk-seo", name: "Norfolk", state: "VA" },
  { slug: "virginia/chesapeake-seo", name: "Chesapeake", state: "VA" },
  { slug: "virginia/arlington-seo", name: "Arlington", state: "VA" },
  { slug: "virginia/richmond-seo", name: "Richmond", state: "VA" },
  { slug: "virginia/newport-news-seo", name: "Newport News", state: "VA" },
  { slug: "virginia/alexandria-seo", name: "Alexandria", state: "VA" },
  { slug: "virginia/hampton-seo", name: "Hampton", state: "VA" },
  { slug: "virginia/roanoke-seo", name: "Roanoke", state: "VA" },
  { slug: "virginia/suffolk-seo", name: "Suffolk", state: "VA" },
  // Colorado
  { slug: "colorado/denver-seo", name: "Denver", state: "CO" },
  { slug: "colorado/colorado-springs-seo", name: "Colorado Springs", state: "CO" },
  { slug: "colorado/aurora-seo", name: "Aurora", state: "CO" },
  { slug: "colorado/fort-collins-seo", name: "Fort Collins", state: "CO" },
  { slug: "colorado/lakewood-seo", name: "Lakewood", state: "CO" },
  { slug: "colorado/thornton-seo", name: "Thornton", state: "CO" },
  { slug: "colorado/arvada-seo", name: "Arvada", state: "CO" },
  { slug: "colorado/westminster-seo", name: "Westminster", state: "CO" },
  { slug: "colorado/pueblo-seo", name: "Pueblo", state: "CO" },
  { slug: "colorado/centennial-seo", name: "Centennial", state: "CO" },
  // Michigan
  { slug: "michigan/detroit-seo", name: "Detroit", state: "MI" },
  { slug: "michigan/grand-rapids-seo", name: "Grand Rapids", state: "MI" },
  { slug: "michigan/warren-seo", name: "Warren", state: "MI" },
  { slug: "michigan/sterling-heights-seo", name: "Sterling Heights", state: "MI" },
  { slug: "michigan/ann-arbor-seo", name: "Ann Arbor", state: "MI" },
  { slug: "michigan/lansing-seo", name: "Lansing", state: "MI" },
  { slug: "michigan/flint-seo", name: "Flint", state: "MI" },
  { slug: "michigan/dearborn-seo", name: "Dearborn", state: "MI" },
  { slug: "michigan/livonia-seo", name: "Livonia", state: "MI" },
  { slug: "michigan/clinton-township-seo", name: "Clinton Township", state: "MI" },
  // Arizona
  { slug: "arizona/phoenix-seo", name: "Phoenix", state: "AZ" },
  { slug: "arizona/tucson-seo", name: "Tucson", state: "AZ" },
  { slug: "arizona/scottsdale-seo", name: "Scottsdale", state: "AZ" },
  { slug: "arizona/mesa-seo", name: "Mesa", state: "AZ" },
  { slug: "arizona/chandler-seo", name: "Chandler", state: "AZ" },
  { slug: "arizona/tempe-seo", name: "Tempe", state: "AZ" },
  { slug: "arizona/gilbert-seo", name: "Gilbert", state: "AZ" },
  { slug: "arizona/glendale-seo", name: "Glendale", state: "AZ" },
  { slug: "arizona/peoria-seo", name: "Peoria", state: "AZ" },
  { slug: "arizona/surprise-seo", name: "Surprise", state: "AZ" },
  // Washington
  { slug: "washington/seattle-seo", name: "Seattle", state: "WA" },
  { slug: "washington/spokane-seo", name: "Spokane", state: "WA" },
  { slug: "washington/tacoma-seo", name: "Tacoma", state: "WA" },
  { slug: "washington/bellevue-seo", name: "Bellevue", state: "WA" },
  { slug: "washington/everett-seo", name: "Everett", state: "WA" },
  { slug: "washington/renton-seo", name: "Renton", state: "WA" },
  { slug: "washington/kirkland-seo", name: "Kirkland", state: "WA" },
  { slug: "washington/redmond-seo", name: "Redmond", state: "WA" },
  { slug: "washington/yakima-seo", name: "Yakima", state: "WA" },
  { slug: "washington/federal-way-seo", name: "Federal Way", state: "WA" },
  // Oregon
  { slug: "oregon/portland-seo", name: "Portland", state: "OR" },
  { slug: "oregon/salem-seo", name: "Salem", state: "OR" },
  { slug: "oregon/eugene-seo", name: "Eugene", state: "OR" },
  { slug: "oregon/gresham-seo", name: "Gresham", state: "OR" },
  { slug: "oregon/hillsboro-seo", name: "Hillsboro", state: "OR" },
  { slug: "oregon/beaverton-seo", name: "Beaverton", state: "OR" },
  { slug: "oregon/bend-seo", name: "Bend", state: "OR" },
  { slug: "oregon/medford-seo", name: "Medford", state: "OR" },
  { slug: "oregon/springfield-seo", name: "Springfield", state: "OR" },
  { slug: "oregon/corvallis-seo", name: "Corvallis", state: "OR" },
  // Nebraska
  { slug: "omaha-ne", name: "Omaha", state: "NE" },
  // Arizona
  { slug: "phoenix-az", name: "Phoenix", state: "AZ" },
  // California
  { slug: "san-francisco-ca", name: "San Francisco", state: "CA" },
  // Washington DC
  { slug: "washington-dc", name: "Washington", state: "DC" },
];

export const testimonials = [
  {
    name: "Marcus T.",
    company: "Precision Electric Co.",
    industry: "Electricians",
    city: "Tampa, FL",
    rating: 5,
    content: "Local Ranking Coach took us from page 3 to the top 3 in Google Maps within 90 days. Our phone hasn't stopped ringing since. Best investment we've made in our business.",
  },
  {
    name: "Sandra R.",
    company: "Cool Air HVAC",
    industry: "HVAC",
    city: "Orlando, FL",
    rating: 5,
    content: "We were invisible online before LRC. Now we rank #1 for 'HVAC repair Orlando' and our leads have tripled. The team is incredibly knowledgeable and responsive.",
  },
  {
    name: "James K.",
    company: "Premier Plumbing Solutions",
    industry: "Plumbers",
    city: "Atlanta, GA",
    rating: 5,
    content: "The ROI has been phenomenal. We're getting 40+ qualified leads per month from organic search alone. Local Ranking Coach truly understands the trades industry.",
  },
  {
    name: "Dr. Lisa M.",
    company: "Bright Smiles Dental",
    industry: "Dental",
    city: "Miami, FL",
    rating: 5,
    content: "Our new patient appointments increased by 65% in just 6 months. The team's understanding of dental SEO and local search is unmatched. Highly recommend.",
  },
  {
    name: "Robert H.",
    company: "Apex Roofing & Construction",
    industry: "Roofers",
    city: "Dallas, TX",
    rating: 5,
    content: "After storm season, we needed to be found fast. LRC got us ranking for emergency roofing keywords in our area within weeks. Outstanding results and service.",
  },
  {
    name: "Maria C.",
    company: "Green Shield Pest Control",
    industry: "Pest Control",
    city: "Phoenix, AZ",
    rating: 5,
    content: "We went from 5 leads a month to over 50 organic leads per month. Local Ranking Coach's systematic approach to local SEO is genuinely impressive.",
  },
];

export const stats = [
  { value: "20+", label: "Years of Experience" },
  { value: "500+", label: "Clients Served" },
  { value: "95%", label: "Client Retention Rate" },
  { value: "3x", label: "Average Lead Increase" },
];

export const faqs = [
  {
    question: "How long does it take to see results from local SEO?",
    answer: "Most clients begin seeing measurable improvements in local rankings within 60–90 days. Significant lead generation increases typically occur within 3–6 months, depending on competition, starting point, and the aggressiveness of the strategy.",
  },
  {
    question: "What makes Local Ranking Coach different from other SEO agencies?",
    answer: "We specialize exclusively in local and trades businesses. With 20+ years of experience, we understand the unique challenges of service-area businesses and have developed proven systems that consistently deliver top-3 Google Maps rankings and measurable ROI.",
  },
  {
    question: "Do you offer services nationwide?",
    answer: "Yes. Local Ranking Coach serves businesses across the entire United States. We have successfully ranked clients in major metros and smaller markets alike, with deep expertise in regional search behavior and local competition dynamics.",
  },
  {
    question: "What industries do you specialize in?",
    answer: "We specialize in service-based and trades businesses including electricians, HVAC companies, plumbers, roofers, general contractors, pest control, healthcare providers, dentists, and more. Our industry-specific knowledge gives our clients a significant competitive advantage.",
  },
  {
    question: "How do you measure SEO success?",
    answer: "We track keyword rankings, Google Maps visibility, organic traffic, phone call volume, form submissions, and ultimately revenue impact. Every client receives a monthly performance report with clear metrics tied to business outcomes.",
  },
  {
    question: "What is included in your local SEO service?",
    answer: "Our local SEO service includes Google Business Profile optimization, citation building and cleanup, on-page SEO, local content creation, review generation strategy, link building, and monthly reporting — all managed by dedicated specialists.",
  },
];
